import useProfile from "hooks/useProfile";
import { useDispatch} from "react-redux";
import { updateProfileDataRequest } from "services/userFlagsService";
import { editUsersFlag } from "store/user";

const ProfileExpiredCards = ({playSound}) => {
  const dispatch = useDispatch();
  const {flags} = useProfile();
  const {view_expired_event} = flags;

  const setIsExpiredCardsShown = async () => {
    playSound('main');
    dispatch(editUsersFlag({field: 'view_expired_event', value: !view_expired_event}))
    try {
      await updateProfileDataRequest({flags: {expiredevent: !view_expired_event}});
    } catch (e) {
      console.log('error of changing view_expired_event in profile:', e);
    }
  };

  return (
    <li className="profile-content__settings-item">
      <b>Show expired cards:</b>
      <input
        type="checkbox"
        id="expired-cards"
        checked={view_expired_event}
        onChange={setIsExpiredCardsShown}
      />
      <label htmlFor="expired-cards"></label>
    </li>
  );
};

export default ProfileExpiredCards;
